const { queue: d3Queue } = require('d3-queue'),
    Eta = require('node-eta'),
    _ = require('underscore');

angular.module('am4').factory('usageReport', (apiUrl, $http, $rootScope, UserService, $q, formatDistanceService, formatStrengthService, $translate, $filter) => {
    const seriesNameFilter = $filter('seriesName'),
        uppercaseFilter = $filter('uppercase'),

        generate = (machines, start_date, end_date, emit) => {
            let errors = {},
                throttledEmit = _.throttle(emit, 1000),
                eta = new Eta(machines.length),
                queue = d3Queue(5);

            eta.start();

            machines.forEach(machine => {
                queue.defer((machine, cb) => {
                    getUsage(machine)
                    .then(res => {
                        cb(null, res);
                    })
                    .catch(e => {
                        cb(e);
                    });
                }, machine);
            });

            const deregisterListenerFn = $rootScope.$on('$stateChangeStart', () => {
                    queue.abort();

                    deregisterListenerFn(); // Cleanup listener
                }),

                promise = new Promise((resolve, reject) => {
                    queue.awaitAll((err, data) => {
                        deregisterListenerFn(); // Cleanup listener

                        if (err) {
                            return reject(err);
                        }

                        resolve(data);
                    });
                });

            function getUsage(machine) {
                return $q.all([
                    UserService.user,
                    $http.get(`${apiUrl}/machines/${machine.frame_serial}/usage`, {
                        params: {
                            start_date,
                            end_date
                        }
                    })
                ])
                .then(([user, res]) => {
                    eta.iterate();

                    throttledEmit(...eta.format('{{eta}},{{progress}}').split(',').map(n => +n));

                    // use machine.modality here because res.data does not contain modality/machine_type_code info
                    const formattedData = formatDistanceService.formatDistanceDelta(res.data, user.unit_preference, machine.modality, false),
                        formattedStrengthData = formatStrengthService.formatStrengthDelta(res.data, user.unit_preference, machine.modality, false);

                    formattedData.console_serial = machine.console_serial;
                    formattedData.machine_type_code = $translate.instant(uppercaseFilter(machine.machine_type_code).replaceAll(' ', '_'));
                    formattedData.series = seriesNameFilter(machine.series);
                    formattedData.facility_id = machine.facility_id;
                    formattedData.nickname = machine.nickname;

                    formattedStrengthData.console_serial = machine.console_serial;
                    formattedStrengthData.machine_type_code = $translate.instant(uppercaseFilter(machine.machine_type_code).replaceAll(' ', '_'));
                    formattedStrengthData.series = seriesNameFilter(machine.series);
                    formattedStrengthData.facility_id = machine.facility_id;

                    return formattedData && formattedStrengthData;
                })
                .catch(e => {
                    console.log(e); // eslint-disable-line no-console

                    if (errors[machine.frame_serial] > 3) {
                        return Promise.reject(`Failed to load usage report for frame_serial ${machine.frame_serial}, exiting`);
                    } else if (errors[machine.frame_serial] > 0) {
                        errors[machine.frame_serial]++;

                        return getUsage(machine);
                    }

                    errors[machine.frame_serial] = 1;
                });
            }

            return {
                promise,
                abort: () => queue.abort()
            };
        };

    let convertDataToPapaTabular = report => {
        const reportCopy = angular.copy(
            report.map(usage => [
                usage.frame_serial,
                usage.console_serial,
                usage.nickname,
                usage.machine_type_code,
                usage.series,
                usage.facility_id,
                usage.timeTranslated,
                usage.distanceTranslated,
                usage.alerts,
                usage.workout_count
            ])
        ), // remove angular $$s

            headerRow = [
                'FRAME_SERIAL_NUMBER',
                'CONSOLE_SERIAL_NUMBER',
                'NAME',
                'EQUIPMENT_TYPE',
                'MODEL',
                'FACILITY_ID',
                'HOURS',
                'DISTANCE',
                'ERRORS',
                'WORKOUTS'
            ].map($translate.instant);

        reportCopy.unshift(headerRow);

        return reportCopy;

    };

    return {
        generate,
        convertDataToPapaTabular
    };
});



// WEBPACK FOOTER //
// ./src/app/services/usageReport.js